"use client";

import React, { useState, useEffect } from "react";

interface ImageDimensionsProps {
  imageData: string;
  className?: string;
}

export default function ImageDimensions({ imageData, className = "" }: ImageDimensionsProps) {
  const [dimensions, setDimensions] = useState<{ width: number; height: number } | null>(null);

  useEffect(() => {
    if (!imageData) {
      setDimensions(null);
      return;
    }

    const img = new window.Image();
    img.onload = () => {
      setDimensions({ width: img.width, height: img.height });
    };
    img.src = imageData;
  }, [imageData]);

  if (!dimensions) {
    return (
      <div className={`text-gray-300 text-xs mt-2 self-end mr-4 ${className}`} aria-hidden>
        <div className="font-mono">— × —px</div>
      </div>
    );
  }

  return (
    <div className={`text-gray-400 text-xs mt-2 self-end mr-4 ${className}`}>
      <div className="font-mono">
        {dimensions.width} × {dimensions.height}px
      </div>
    </div>
  );
}
